"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerificationArgsSerializer = exports.VerificationArgs = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var VerificationArgs;
(function (VerificationArgs) {
    VerificationArgs[VerificationArgs["CreatorV1"] = 0] = "CreatorV1";
    VerificationArgs[VerificationArgs["CollectionV1"] = 1] = "CollectionV1";
})(VerificationArgs = exports.VerificationArgs || (exports.VerificationArgs = {}));
function getVerificationArgsSerializer() {
    return (0, serializers_1.scalarEnum)(VerificationArgs, {
        description: 'VerificationArgs',
    });
}
exports.getVerificationArgsSerializer = getVerificationArgsSerializer;
//# sourceMappingURL=verificationArgs.js.map